var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Notifikace\n  "),_c('v-btn',{on:{"click":_vm.test}},[_vm._v("TEST1")]),_c('v-text-field',{model:{value:(_vm.nickname),callback:function ($$v) {_vm.nickname=$$v},expression:"nickname"}}),_c('v-btn',{on:{"click":_vm.sendNicknameNotification}},[_vm._v("Simulace notifikace - Poslat přezdívku")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }